"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.IntegrationEnvironment = exports.ProductionEnvironment = void 0;
const ProductionEnvironment = {
  feedbackServiceBaseUrl: "https://api.feedback.cimpress.io",
  useCache: true
};
exports.ProductionEnvironment = ProductionEnvironment;
const IntegrationEnvironment = {
  feedbackServiceBaseUrl: "https://int-api.feedback.cimpress.io",
  useCache: true
};
exports.IntegrationEnvironment = IntegrationEnvironment;